export default "__VITE_ASSET__CVY1Kmci__"